import { resolveUtmSourceAndMedium, readSessionString } from "../utils/utmParams";

function pickFromUrlOrSession(key) {
  if (typeof window === "undefined") return null;
  try {
    const fromUrl = new URLSearchParams(window.location.search).get(key);
    if (fromUrl != null && String(fromUrl).trim() !== "") {
      return String(fromUrl).trim();
    }
  } catch {
    // ignore
  }
  return readSessionString(key);
}

export function getUtmParams() {
  if (typeof window === "undefined") {
    return {
      utm_source: null,
      utm_medium: null,
      utm_campaign: null,
      utm_term: null,
    };
  }

  const { utm_source, utm_medium } = resolveUtmSourceAndMedium();

  return {
    utm_source,
    utm_medium,
    utm_campaign: pickFromUrlOrSession("utm_campaign"),
    utm_term: pickFromUrlOrSession("utm_term"),
  };
}

export function saveUtmParams() {
  if (typeof window === "undefined" || typeof sessionStorage === "undefined") return;

  const { utm_source, utm_medium } = resolveUtmSourceAndMedium();

  try {
    sessionStorage.setItem("utm_source", utm_source);
    sessionStorage.setItem("utm_medium", utm_medium);

    let q;
    try {
      q = new URLSearchParams(window.location.search);
    } catch {
      q = null;
    }
    if (q) {
      const campaign = q.get("utm_campaign");
      if (campaign != null && String(campaign).trim() !== "") {
        sessionStorage.setItem("utm_campaign", String(campaign).trim());
      }
      const term = q.get("utm_term");
      if (term != null && String(term).trim() !== "") {
        sessionStorage.setItem("utm_term", String(term).trim());
      }
    }
  } catch {
    // ignore
  }
}
